/* eslint-disable comma-dangle */
/* eslint-disable quotes */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

export const AuthenticateRoute = (props) => {
  const ACCESS_DENIED_ROUTE_KEY = "accessDeniedRedirectRoute";
  const menuItemsArr = [
    "/order",
    "/order-history",
    "/dva",
    "/drafts",
    "/claims",
    "/return",
    "/return-history",
    "/mask-guarantee",
    "/mask-guarantee-history",
    "/warranty",
    "/payments",
    "/my-account",
    "/my-company",
    "/dvaManualForms",
  ];
  const { children, path, ...rest } = props;
  const { menuItems } = useSelector((state) => state?.headerProductSearch);
  const { accountSwitched } = useSelector((state) => state.setUser);
  const { myAccountPermission, myCompanyPermission } = useSelector(
    (state) => state.authentication
  );
  const dispatch = useDispatch();
  const history = useNavigate();
  const stripStoreBasename = (pathname = '') => pathname.replace(/^\/store(?=\/|$)/, '');
  const getCurrentRoute = () => stripStoreBasename(globalThis.location.pathname) || '/';
  const canAccessRoute = (route, links) => links.some((item) => route === item.link || route.startsWith(`${item.link}/`));
  const getMenuAlter = (menuItem) => {
    let subMenu = [];
    const flattenMenuItems = menuItem?.map((menu) => {
      if (menu["sub-menu"] && menu["sub-menu"].length) {
        subMenu = [...subMenu, ...menu["sub-menu"]];
      }
      return menu;
    });
    return [
      ...flattenMenuItems,
      ...(subMenu.length ? getMenuAlter(subMenu) : subMenu),
      ...[
        {
          "account-enabled": myAccountPermission === "Y",
          link: "/my-account",
          name: "myAccount",
          type: myAccountPermission === "Y" ? "Link" : "a",
        },
        {
          "account-enabled": myCompanyPermission === "Y",
          link: "/my-company",
          name: "myCompany",
          type: myCompanyPermission === "Y" ? "Link" : "a",
        },
      ],
    ];
  };

  const setMenuAvailableState = () => {
    dispatch({ type: "IS_MENU_CHECK", payload: true });
  };

  const handleAccessDeniedRoute = (deniedRoute, filteredMenuLink, canAccessPlaceOrder) => {
    if (path !== '/accessDenied') {
      return false;
    }

    const hasDeniedRoute = Boolean(deniedRoute && deniedRoute !== '/accessDenied');

    if (hasDeniedRoute) {
      if (canAccessRoute(deniedRoute, filteredMenuLink)) {
        sessionStorage.removeItem(ACCESS_DENIED_ROUTE_KEY);
        history(deniedRoute);
        return true;
      }

      // Route is stale for current permissions; clear it before fallback behavior.
      sessionStorage.removeItem(ACCESS_DENIED_ROUTE_KEY);
      if (canAccessPlaceOrder) {
        history('/order');
      }
      return true;
    }

    if (canAccessPlaceOrder) {
      sessionStorage.removeItem(ACCESS_DENIED_ROUTE_KEY);
      history('/order');
      return true;
    }

    return true;
  };

  const redirectToAccessDenied = () => {
    sessionStorage.setItem(ACCESS_DENIED_ROUTE_KEY, getCurrentRoute());
    setMenuAvailableState();
    history('/accessDenied');
  };

  useEffect(() => {
    if (!menuItems?.length) {
      return;
    }

    const formattedMenuItems = getMenuAlter(menuItems);
    dispatch({ type: "FORMATTED_MENU", payload: formattedMenuItems });

    const currentPathname = globalThis.location.pathname;
    if (!currentPathname.includes(path)) {
      return;
    }

    const isMatchingPath = (link) => currentPathname === `/store${link}`;
    const isMenuAvailableCheck = formattedMenuItems?.some((menu) => {
      if (isMatchingPath(menu?.link)) {
        return true;
      }

      return menu["second-level-sub-menu"]?.some((subMenu) =>
        isMatchingPath(subMenu?.link)
      );
    });
    const filteredMenuLink = formattedMenuItems.filter((menu) => menu.type === 'Link');
    const hasMenuLinks = filteredMenuLink.length > 0;
    const isPathInMenuItems = menuItemsArr.includes(path);
    const canAccessPlaceOrder = filteredMenuLink.some((menu) => menu.link === '/order');
    const deniedRoute = sessionStorage.getItem(ACCESS_DENIED_ROUTE_KEY);

    if (handleAccessDeniedRoute(deniedRoute, filteredMenuLink, canAccessPlaceOrder)) {
      return;
    }

    if (isMenuAvailableCheck) {
      setMenuAvailableState();
      return;
    }

    if (!isPathInMenuItems || !hasMenuLinks) {
      return;
    }

    redirectToAccessDenied();
  }, [menuItems, accountSwitched]);

  return children;
};

export default AuthenticateRoute;
